import React from 'react';
import { TypedMemo } from '../../common/types';
import { Music24Logo } from '../components/Music24Logo';
/* eslint-disable css-modules/no-unused-class -- one stylesheet per screen; each part of the screen uses its own slice of it */
import styles from './Social.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface Music24MarkProps {
  /** The text next to the logo: "Music24" in a table row, "Published with Music24" in the detail. */
  label: string;
  /** Shows the logo only. The label stays as the accessible name (the phone list). */
  iconOnly?: boolean;
}

/** The mark of a post that Music24 published (a post with `scheduledPostUuid`). */
const Music24MarkComponent: React.FC<Music24MarkProps> = ({ label, iconOnly = false }) => (
  <span className={styles.m24} title={iconOnly ? label : undefined} data-testid="music24-mark">
    <Music24Logo size={11} />
    {iconOnly ? <span className="visually-hidden">{label}</span> : label}
  </span>
);

export const Music24Mark = TypedMemo(Music24MarkComponent);
